import { CheckboxField, TextField } from "~/components/Form";
import { EditLqsResourceForm, useApiKey, useUpdateApiKey } from "~/lqs";
import { makeApiKeyLocation, useApiKeyParams } from "~/paths";
import { selectData } from "~/utils";
import { EDITABLE_API_KEY_FIELDS, editApiKeySchema } from "../schemas";

export function ApiKeyEditForm() {
  const { apiKeyId } = useApiKeyParams();

  return (
    <EditLqsResourceForm
      schema={editApiKeySchema}
      resourceName="API key"
      query={useApiKey(apiKeyId, { select: selectData })}
      editableFields={EDITABLE_API_KEY_FIELDS}
      mutation={useUpdateApiKey(apiKeyId)}
      detailsLocation={makeApiKeyLocation({ apiKeyId })}
    >
      {(control) => (
        <>
          <TextField control={control} name="name" required />
          <CheckboxField control={control} name="disabled" />
        </>
      )}
    </EditLqsResourceForm>
  );
}
